import React from "react";
// images
import CalendarIcon from "../../Assets/images/calendar.svg";
import CloseIcon from "../../Assets/images/close.svg";
import SearchIcon from "../../Assets/images/search.svg";
import Date from "../../Components/FormControl/Date/Date";
import RadioBox from "Components/FormControl/RadioBox/RadioBox";
import styles from "./index.module.scss";
import CheckBox from "Components/FormControl/CheckBox/CheckBox";
import Select from "Components/FormControl/Select/Select";
import {
  DATE_FILTER_TYPE,
  DATE_TYPE,
  DEFAULT_TIMEZONE,
} from "Helpers/Constants";
import moment from "moment";
import { convertDateTime } from "Helpers/date";
import momentTimezone from "moment-timezone";
import ExportIcon from "./../../Assets/images/Export.svg";
import { CSVLink } from "react-csv";
const GlobalDateFilters = ({
  isAllCheckStoreBnt,
  isFilterByOption,
  isDateFilter,
  isClearSearchBtn,
  isSearchBtn,
  isExportBtn,
  isFilterByPeriod,
  isSearchIcon,
  storeTimezone,
  isSelectedPeriodLabel,
  ...props
}) => {
  const defaultFilterByOption = [
    {
      label: "Order date",
      value: "order_date",
    },
    {
      label: "Delivery date",
      value: "delivery_date",
    },
  ];
  const filterByOptions = props?.filterByOptions
    ? [...props?.filterByOptions]
    : defaultFilterByOption;

  const defaultPeriodOptions = [
    {
      title: "Weekly",
      id: "weekly",
    },
    {
      title: "Monthly",
      id: "monthly",
    },
    {
      title: "Yearly",
      id: "yearly",
    },
  ];

  const periodOptions = props?.periodOptions
    ? [...props?.periodOptions]
    : defaultPeriodOptions;

  const handleDateSelectionFilter = (
    date = "",
    type = "",
    format = "YYYY-MM-DD",
    datePeriod = null
  ) => {
    if (type === DATE_TYPE.TO_DATE) {
      if (!datePeriod) {
        props.setToDate(date);
      } else {
        const dateFilterType = DATE_FILTER_TYPE[datePeriod];
        switch (dateFilterType) {
          case DATE_FILTER_TYPE.weekly:
            const startOfWeek = moment(date).subtract(6, "days").format(format);
            const endOfWeek = moment(date).format(format);
            props.setFromDate(startOfWeek);
            props.setToDate(endOfWeek);
            return;
          case DATE_FILTER_TYPE.monthly:
            const startOfMonth = moment(date)
              .subtract(1, "month")
              .add(1, "day")
              .format(format);
            const endOfMonth = moment(date).format(format);
            props.setFromDate(startOfMonth);
            props.setToDate(endOfMonth);
            return;
          case DATE_FILTER_TYPE.yearly:
            const startOfYear = moment(date)
              .subtract(1, "year")
              .add(1, "day")
              .format(format);
            const endOfYear = moment(date).format(format);
            props.setFromDate(startOfYear);
            props.setToDate(endOfYear);
            return;
          case DATE_FILTER_TYPE.custom:
            const startOfCustom = moment(props.fromDate).format(format);
            const endOfCustom = moment(date).format(format);
            props.setFromDate(startOfCustom);
            props.setToDate(endOfCustom);
            return;
          default:
            props.setFromDate(moment(props.fromDate).format(format));
            props.setToDate(moment(props.toDate).format(format));
            return;
        }
      }
    } else {
      if (!datePeriod) {
        props.setFromDate(date);
      } else {
        const dateFilterType = DATE_FILTER_TYPE[datePeriod];
        switch (dateFilterType) {
          case DATE_FILTER_TYPE.weekly:
            const endOfWeek = moment(date).add(6, "days").format(format);
            const startOfWeek = moment(date).format(format);
            props.setFromDate(startOfWeek);
            props.setToDate(endOfWeek);
            return;
          case DATE_FILTER_TYPE.monthly:
            const endOfMonth = moment(date)
              .add(1, "month")
              .subtract(1, "day")
              .format(format);
            const startOfMonth = moment(date).format(format);
            props.setFromDate(startOfMonth);
            props.setToDate(endOfMonth);
            return;
          case DATE_FILTER_TYPE.yearly:
            const endOfYear = moment(date)
              .add(1, "year")
              .subtract(1, "day")
              .format(format);
            const startOfYear = moment(date).format(format);
            props.setFromDate(startOfYear);
            props.setToDate(endOfYear);
            return;
          case DATE_FILTER_TYPE.custom:
            const endOfCustom = moment(props.toDate).format(format);
            const startOfCustom = moment(date).format(format);
            props.setFromDate(startOfCustom);
            props.setToDate(endOfCustom);
            return;
          default:
            props.setFromDate(moment(props.fromDate).format(format));
            props.setToDate(moment(props.toDate).format(format));
            return;
        }
      }
    }
  };

  const handleSelectedPeriod = (datePeriod, format = "YYYY-MM-DD") => {
    const dateFilterType = DATE_FILTER_TYPE[datePeriod];
    switch (dateFilterType) {
      case DATE_FILTER_TYPE.today:
        const startOfToday = momentTimezone
          .tz(storeTimezone || DEFAULT_TIMEZONE)
          .format(format);
        const endOfToday = momentTimezone
          .tz(storeTimezone || DEFAULT_TIMEZONE)
          .format(format);
        props.setFromDate(startOfToday);
        props.setToDate(endOfToday);
        return;
      case DATE_FILTER_TYPE.yesterday:
        const startOfYesterday = momentTimezone
          .tz(storeTimezone || DEFAULT_TIMEZONE)
          .subtract(1, "days")
          .format(format);
        const endOfYesterday = momentTimezone
          .tz(storeTimezone || DEFAULT_TIMEZONE)
          .subtract(1, "days")
          .format(format);
        props.setFromDate(startOfYesterday);
        props.setToDate(endOfYesterday);
        return;
      case DATE_FILTER_TYPE.weekly:
        const startOfWeek = moment().startOf("isoWeek").format(format);
        const endOfWeek = moment().endOf("isoWeek").format(format);
        props.setFromDate(startOfWeek);
        props.setToDate(endOfWeek);
        return;
      case DATE_FILTER_TYPE.monthly:
        const startOfMonth = moment().startOf("month").format(format);
        const endOfMonth = moment().endOf("month").format(format);
        props.setFromDate(startOfMonth);
        props.setToDate(endOfMonth);
        return;
      case DATE_FILTER_TYPE.yearly:
        const startOfYear = moment().startOf("year").format(format);
        const endOfYear = moment().endOf("year").format(format);
        props.setFromDate(startOfYear);
        props.setToDate(endOfYear);
        return;
      case DATE_FILTER_TYPE.lastMonth:
        const startOfLastMonth = moment().subtract(1, "month").startOf("month").format(format);
        const endOfLastMonth = moment().subtract(1, "month").endOf("month").format(format);
        props.setFromDate(startOfLastMonth);
        props.setToDate(endOfLastMonth);
        return;
      case DATE_FILTER_TYPE.lastYear:
        const startOfLastYear = moment().subtract(1, "year").startOf("year").format(format);
        const endOfLastYear = moment().subtract(1, "year").endOf("year").format(format);
        props.setFromDate(startOfLastYear);
        props.setToDate(endOfLastYear);
        return;
      case DATE_FILTER_TYPE.thisMonth:
        const startOfThisMonth = moment().startOf("month").format(format);
        const endOfThisMonth = moment().endOf("month").format(format);
        props.setFromDate(startOfThisMonth);
        props.setToDate(endOfThisMonth);
        return;
      case DATE_FILTER_TYPE.thisYear:
        const startOfThisYear = moment().startOf("year").format(format);
        const endOfThisYear = moment().endOf("year").format(format);
        props.setFromDate(startOfThisYear);
        props.setToDate(endOfThisYear);
        return;
      default:
        props.setFromDate(moment(props.fromDate).format(format));
        props.setToDate(moment(props.toDate).format(format));
        return;
    }
  };

  const handleSelectedPeriodLabel = (data) => {
    if (isSelectedPeriodLabel) {
      const label = periodOptions.find((option) => option.id === data)?.label;
      if(label !== DATE_FILTER_TYPE.custom){
        props.setSelectedPeriodLabel(label);
      }else{
        props.setSelectedPeriodLabel(props?.selectedPeriodLabel);
      }
    }
  };

  const reference = React.useRef(null);

  return (
    <div className={"row d-flex align-items-end"}>
      <div className="col-sm-12 col-xs-12">
        <div className="col-12 d-flex align-items-center p-0">
          {isFilterByOption && (
            <div className="col-6 d-flex align-items-center">
              <span
                className="mb-0 mt-2 pb-0 d-inline-bock mr-3"
                style={{ lineHeight: 1, whiteSpace: "nowrap" }}
              >
                Filter By
              </span>
              {filterByOptions.map((option) => (
                <span style={{ whiteSpace: "nowrap" }}>
                  <RadioBox
                    key={option.value}
                    selectedValue={props.type}
                    onChange={() => {
                      if (props.setType) {
                        props.setType(option.value);
                      }
                    }}
                    label={option.label}
                    value={option.value}
                  />
                </span>
              ))}
            </div>
          )}
        </div>
        <div className="col-12 d-flex align-items-center p-0">
          {isFilterByPeriod && (
            <div className="col-sm-2 col-xs-12">
              <Select
                label={isSelectedPeriodLabel ? props?.selectedPeriodLabel : ""}
                value={props?.selectedPeriod}
                onChange={(data) => {
                  props.setSelectedPeriod(data);
                  handleSelectedPeriod(data, props.dateFormate);
                  isSelectedPeriodLabel && handleSelectedPeriodLabel(data);
                }}
                options={periodOptions}
                disabled={false}
              />
            </div>
          )}

          {isDateFilter && (
            <>
              <div className="col-sm-4 col-xs-12">
                <Date
                  label={props?.fromDateLabel || "Filter From"}
                  value={convertDateTime(
                    moment(props.fromDate).format("YYYY-MM-DD"),
                    "iso4",
                    "ccc LLL dd, yyyy"
                  )}
                  dateFormat="ddd MMM DD, YYYY"
                  type="date"
                  fieldIcon={CalendarIcon}
                  onChange={(fromDate) => {
                    handleDateSelectionFilter(
                      fromDate,
                      DATE_TYPE.FROM_DATE,
                      props.dateFormate,
                      isFilterByPeriod ? props?.selectedPeriod : null
                    );
                  }}
                  disabled={props?.isDisabled || false}
                  isTimeStamp={false}
                />
              </div>
              <div className="col-sm-3 col-xs-12">
                <Date
                  label={props?.toDateLabel || "Filter To"}
                  value={convertDateTime(
                    moment(props.toDate).format("YYYY-MM-DD"),
                    "iso4",
                    "ccc LLL dd, yyyy"
                  )}
                  dateFormat="ddd MMM DD, YYYY"
                  type="date"
                  fieldIcon={CalendarIcon}
                  onChange={(toDate) => {
                    handleDateSelectionFilter(
                      toDate,
                      DATE_TYPE.TO_DATE,
                      props.dateFormate,
                      isFilterByPeriod ? props?.selectedPeriod : null
                    );
                  }}
                  disabled={props?.isDisabled || false}
                  isTimeStamp={false}
                />
              </div>
            </>
          )}
          {/* {isAllCheckStoreBnt && (
            <div className="col-sm-2 col-xs-12 ml-3">
              <CheckBox
                value={props.defaultSetCheckAllStore}
                label="All Stores"
                onChange={(data) => {
                  props?.checkAllStore(data);
                }}
              />
            </div>
          )} */}
          <div className="col-sm-3 col-xs-12 d-flex align-items-center">
            <div className="td-actions">
              {isAllCheckStoreBnt && (
                <span className="ml-3" style={{ whiteSpace: "nowrap" }}>
                  <CheckBox
                    value={props.defaultSetCheckAllStore}
                    label="All Stores"
                    onChange={(data) => {
                      props?.checkAllStore(data);
                    }}
                  />
                </span>
              )}
            </div>
            <div className="td-actions pt-2 d-flex align-items-center">
              {isSearchIcon && (
                <span
                  onClick={(e) => props?.fetchData()}
                  className={`link cursor-pointer ${styles.searchIconWrapper}`}
                >
                  <img className={styles.searchIcon} src={SearchIcon} alt="" />
                </span>
              )}
              {isSearchBtn && (
                <span className="col-2">
                  <button
                    className="btn gray-btn d-inline-block mb-1 mr-2 mt-0"
                    onClick={() => props?.fetchData()}
                  >
                    Search
                  </button>
                </span>
              )}

              {isClearSearchBtn && (
                <span
                  onClick={(e) => props?.handleClearSearch(e)}
                  className={`link cursor-pointer ml-3 ${styles.clearIconWrapper}`}
                >
                  <img className={styles.clearIcon} src={CloseIcon} alt="" />
                </span>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="col-sm-1 col-xs-12 d-flex align-items-center justify-content-end mb-3">
        {isExportBtn && (
          <div className={`mr-2`}>
            {props?.exportData && props?.exportData.length > 0 && (
              <CSVLink
                ref={reference}
                style={{
                  display: "none",
                  float: "right",
                  marginTop: "25px",
                }}
                data={props?.exportData}
                headers={props?.exportHeader}
                filename={"orderLookup.csv"}
                className={`link csvLink cursor-pointer ml-3 ${styles.searchIconWrapper}`}
              >
                DownLoad
              </CSVLink>
            )}
            <span
              onClick={props?.handleExport}
              className={`link cursor-pointer ${styles.searchIconWrapper}`}
              style={{ float: "right" }}
            >
              <img className={styles.searchIcon} src={ExportIcon} alt="" />
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default GlobalDateFilters;
